import { render, staticRenderFns } from "./EligibilityComponent.vue?vue&type=template&id=379943c1&scoped=true"
import script from "./EligibilityComponent.vue?vue&type=script&lang=ts"
export * from "./EligibilityComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379943c1",
  null
  
)

export default component.exports